import { ObjectEstate } from "@/classes/ObjectEstate"
import { collection, getDocs, onSnapshot, query, Unsubscribe, where } from "firebase/firestore"
import { Module } from "vuex"
import store from ".."

export interface ObjectState {
    objects: ObjectEstate[]
    isLoading: boolean
    firestoreListener: {
        objects: Unsubscribe | null
    }
}

const module: Module<ObjectState, unknown> = {
    state: {
        objects: [],
        isLoading: true,
        firestoreListener: {
            objects: null
        }
    },
    actions: {
        getObject({ state }, id: string) {
            return new Promise(async (resolve, reject) => {
                for (const customer of state.objects) {
                    if (customer.id == id) {
                        resolve(customer)
                        return
                    }
                }
                const company = store.state.company!.company!
                const _i = new ObjectEstate(company, id)
                if (await _i.load()) {
                    state.objects.push(_i)
                    resolve(_i)
                    return
                }
                reject(new Error("not_found"))
            })
        },
        searchObject({ state }, search: string) {
            return new Promise(async (resolve, reject) => {
                if (!search) {
                    reject(new Error("no_search_term"))
                    return
                }
                const searchTerms = search.toUpperCase().split(" ")
                const company = store.state.company!.company!
                const collectionRef = collection(company.ref, "object")
                const queryRef = query(
                    collectionRef,
                    where("_searchIndex", "array-contains-any", searchTerms)
                )
                const searchResults = await getDocs(queryRef)
                const objectEstate: ObjectEstate[] = []
                for (const result of searchResults.docs) {
                    const _i = new ObjectEstate(company, result.id)
                    _i.fromData(result.data())
                    const objectEstateIndex = state.objects.findIndex((a) => a.id == _i.id)
                    if (objectEstateIndex == -1) {
                        state.objects.push(_i)
                    }
                    objectEstate.push(_i)
                }
                resolve(objectEstate)
            })
        },
        attachRequestObjects({ state }) {
            return new Promise((resolve, reject) => {
                if (state.firestoreListener.objects) {
                    state.isLoading = false
                    resolve(state.objects)
                    return
                }
                state.isLoading = true
                const company = store.state.company!.company!
                if(!company) {
                    return
                }
                const ref = query(
                    collection(company.ref, "object"),
                    where("financer", "==", store.state.auth!.profile!.sub),
                    where("state", "in", [
                        "financer_reply",
                        "redirected"
                    ])
                )
                state.firestoreListener.objects = onSnapshot(ref, (snapshot) => {
                    state.objects = []
                    for (const doc of snapshot.docs) {
                        const objcetEstate = new ObjectEstate(company, doc.id)
                        objcetEstate.fromData(doc.data())
                        state.objects.push(objcetEstate)
                    }
                    state.isLoading = false
                    resolve(state.objects)
                }, (err) => {
                    reject(err)
                })
            })
        }
    }
}
export default module